import axios from 'axios';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api';

// Check if user is authenticated
export const checkAuthStatus = async () => {
  try {
    const response = await axios.get(`${API_URL}/auth/user`);
    return response.data;
  } catch (error) {
    console.error('Error checking auth status:', error);
    return { isAuthenticated: false, user: null };
  }
};

// Logout user
export const logout = async () => {
  try {
    await axios.get(`${API_URL}/auth/logout`);
    return { success: true };
  } catch (error) {
    console.error('Error logging out:', error);
    return { success: false, error };
  }
}; 